export default __webpack_public_path__ + "translate-chrome-1.png";